import * as i0 from '@angular/core';
import { input, signal, viewChild, afterRenderEffect, ViewEncapsulation, ChangeDetectionStrategy, Component, NgModule } from '@angular/core';
import { MatProgressSpinner, MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule } from '@angular/common';
const _c0 = ["content"];
const _c1 = ["*"];
function ZvBlockUi_Conditional_3_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.spinnerText());
  }
}
function ZvBlockUi_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3)(2, "div", 4);
    i0.ɵɵelement(3, "mat-spinner", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, ZvBlockUi_Conditional_3_Conditional_4_Template, 2, 1, "div", 6);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("diameter", ctx_r0.spinnerDiameter());
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.spinnerText() ? 4 : -1);
  }
}
let ZvBlockUi = /*#__PURE__*/(() => {
  class ZvBlockUi {
    blocked = input.required();
    spinnerText = input('');
    clickthrough = input(false);
    spinnerDiameter = signal(20); // start with min width and then see if we can increase it in updateSpinner
    contentNode = viewChild.required('content');
    constructor() {
      afterRenderEffect(() => {
        if (this.blocked()) {
          this.updateSpinner();
        }
      });
    }
    updateSpinner() {
      const nativeEl = this.contentNode().nativeElement;
      const minDimension = Math.min(nativeEl.offsetWidth, nativeEl.offsetHeight);
      const textSpace = this.spinnerText() ? 20 : 0;
      const newDiameter = Math.max(Math.min(minDimension - textSpace, 100), 20);
      this.spinnerDiameter.set(newDiameter);
    }
    static ɵfac = function ZvBlockUi_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ZvBlockUi)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ZvBlockUi,
      selectors: [["zv-block-ui"]],
      viewQuery: function ZvBlockUi_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuerySignal(ctx.contentNode, _c0, 5);
        }
        if (rf & 2) {
          i0.ɵɵqueryAdvance();
        }
      },
      hostVars: 2,
      hostBindings: function ZvBlockUi_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("zv-block-ui__clickthrough", ctx.clickthrough());
        }
      },
      inputs: {
        blocked: [1, "blocked"],
        spinnerText: [1, "spinnerText"],
        clickthrough: [1, "clickthrough"]
      },
      ngContentSelectors: _c1,
      decls: 4,
      vars: 1,
      consts: [["content", ""], [1, "zv-block-ui__content"], [1, "zv-block-ui__overlay"], [1, "zv-block-ui__overlay-content"], [1, "zv-block-ui__spinner-container"], [1, "zv-block-ui__spinner", 3, "diameter"], [1, "zv-block-ui__text"]],
      template: function ZvBlockUi_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "div", 1, 0);
          i0.ɵɵprojection(2);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(3, ZvBlockUi_Conditional_3_Template, 5, 2, "div", 2);
        }
        if (rf & 2) {
          i0.ɵɵadvance(3);
          i0.ɵɵconditional(ctx.blocked() ? 3 : -1);
        }
      },
      dependencies: [MatProgressSpinner],
      styles: ["zv-block-ui{display:grid;position:relative}.zv-block-ui__clickthrough{pointer-events:none}.zv-block-ui__clickthrough>.zv-block-ui__content{pointer-events:auto}.zv-block-ui__content{grid-column:1;grid-row:1;min-width:0;align-self:baseline}.zv-block-ui__overlay{grid-column:1;grid-row:1;z-index:2;background-color:#f4f4f499;display:flex;justify-content:center;align-items:center}.zv-block-ui__spinner-container{overflow:hidden}.zv-block-ui__spinner{display:inline-block;margin:auto;color:var(--zv-components-primary);opacity:1}.zv-block-ui__overlay-content{text-align:center;position:sticky;top:10%;bottom:10%}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return ZvBlockUi;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** @deprecated block-ui component is standalone now */
let ZvBlockUiModule = /*#__PURE__*/(() => {
  class ZvBlockUiModule {
    static ɵfac = function ZvBlockUiModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ZvBlockUiModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ZvBlockUiModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, MatProgressSpinnerModule, ZvBlockUi]
    });
  }
  return ZvBlockUiModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// export what ./public_api exports so we can import with the lib name like this:
// import { ModuleA } from 'libname'

/**
 * Generated bundle index. Do not edit.
 */

export { ZvBlockUi, ZvBlockUiModule };
